import React from 'react';
import classNames from 'classnames';
import toggleIcon from '../images/toggle-arrow.svg';
import { isEs } from "../libs/lang";

// can make more generic and pass in img and alt props if needed

// handleClick ==> Pass when handleclick is added
const ToggleableIcon = ({  isUp, stylesButton, className, src, ...rest }) => {

    let defaultStyles = stylesButton || '';
    let alt = isEs() ? 'flecha descendente' : 'down arrow opens category dropdown';

    if (isUp) {
        defaultStyles = [defaultStyles, 'isUp'].join(' ');
        alt = isEs() ? 'flecha ascendente' : 'up arrow closes category dropdown';
    }

    // onClick={handleClick} add when handleclick is added
    return (
		// eslint-disable-next-line react/jsx-props-no-spreading
        <span {...rest} className={classNames(defaultStyles, className)} >
            <img src={src || toggleIcon} alt={alt} />
        </span>
    );
};

export default ToggleableIcon;
